var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    enableBackground: "new 0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M18.5833 17.4166L15.0833 13.9166C14.9166 13.75 14.9166 13.5834 15.0833 13.3334C16.25 11.75 16.8333 9.6666 16.4999 7.4166C15.9999 4.08327 13.3332 1.41669 9.99988 0.833352C4.58321 -0.0833149 -0.000120997 4.58335 0.833212 10C1.41655 13.3334 4.08313 16 7.41646 16.5C9.66646 16.8333 11.7499 16.25 13.3332 15.0833C13.4999 15 13.7498 15 13.9165 15.0833L17.4165 18.5833C17.7498 18.9166 18.2499 18.9166 18.5833 18.5833C18.9166 18.3333 18.9166 17.7499 18.5833 17.4166ZM2.49988 8.75002C2.49988 5.33335 5.33321 2.50002 8.74988 2.50002C12.1665 2.50002 14.9999 5.33335 14.9999 8.75002C14.9999 12.1667 12.1665 15 8.74988 15C5.33321 15 2.49988 12.1667 2.49988 8.75002Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.4c7094f2.svg";
export { ForwardRef as ReactComponent };